module.exports = __webpack_public_path__ + "static/img/bs_content4.3f7bb1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bs_content4.png
// module id = f7lj
// module chunks = 0